import { AxiosInstance } from "axios";
import { ResponseDto, ResponseLSDto } from "@common/ict/model/interface/common";
import { DelistDto } from "@/zh-website/src/views/Colleges/model/interface";

export class EducationCasesApi {
  static getCaseDetail(request: AxiosInstance, query) {
    return request.get<ResponseDto, ResponseDto>(
      `zh-business/client/v1/college/education/cooperation/detail`,
      {
        params: query
      }
    );
  }
}
